function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useFormik } from 'formik';
import _ from 'lodash/fp';
import T from 'prop-types';
import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { MEMBERSHIP } from '../../constants/membership';
import usePromiseWrapper from '../../hooks/usePromiseWrapper';
import { alertError } from '../../redux/actions';
import text from '../../text';
import { client } from '../../utilities/api';
import assert from '../../utilities/assert';
import { captureError } from '../../utilities/error';
import { calculateRemainderDays, calculateTrialLengthDays } from '../../utilities/membership';
import { getUserMembership } from '../../utilities/user';
import { Button } from '../button';
import { Control } from '../form';
export var GIVE_USER_TRIAL_MODAL = 'GIVE_USER_TRIAL_MODAL';
var GiveUserTrialModal = function(_param) {
    var user = _param.user, show = _param.show, onHide = _param.onHide, rest = _object_without_properties(_param, [
        "user",
        "show",
        "onHide"
    ]);
    var dispatch = useDispatch();
    var formik = useFormik({
        initialValues: {
            days: ''
        },
        validate: function(param) {
            var days = param.days;
            var errors = {};
            days = days.trim();
            if (days === '') {
                errors.days = 'Required';
            } else if (!/^\d+$/.test(days)) {
                errors.days = 'Not a valid positive integer';
            } else {
                var asInt = parseInt(days, 10);
                if (isNaN(asInt)) {
                    throw new Error("Could not parseInt: ".concat(days));
                }
                // coordinate with backend
                if (asInt < 1 || asInt > 100) {
                    errors.days = 'Please enter a value between 1 and 100';
                }
            }
            return errors;
        },
        onSubmit: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param, param1) {
                var days, setSubmitting, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            days = param.days, setSubmitting = param1.setSubmitting;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                addDaysToTrial(days)
                            ];
                        case 2:
                            _state.sent();
                            onHide && onHide();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            err = _state.sent();
                            captureError(err);
                            dispatch(alertError('Failed to add days to trial'));
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setSubmitting(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_, _1) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    var _usePromiseWrapper = usePromiseWrapper(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(days) {
            var data;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        assert(!_.isNil(user === null || user === void 0 ? void 0 : user.id));
                        return [
                            4,
                            client.giveUserTrial(user.id, {
                                priceId: MEMBERSHIP.MONTHLY.PRICE_ID,
                                days: days
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(days) {
            return _ref.apply(this, arguments);
        };
    }(), [
        user === null || user === void 0 ? void 0 : user.id
    ] // keep the ?: modal props can be undefined
    ), addDaysToTrial = _usePromiseWrapper.run;
    var daysLeftOfTrial = useMemo(function() {
        var membership = getUserMembership(user);
        if (!membership || membership.status !== 'trialing') return null;
        return calculateRemainderDays(membership);
    }, [
        user
    ]);
    var trialLengthInDays = useMemo(function() {
        var membership = getUserMembership(user);
        if (!membership || membership.status !== 'trialing') return null;
        return calculateTrialLengthDays(membership);
    }, [
        user
    ]);
    return /*#__PURE__*/ React.createElement(Modal, _object_spread({
        centered: true,
        scrollable: true,
        show: show,
        onHide: onHide
    }, rest), /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "align-end",
        closeButton: true
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h3", {
        className: "secondary"
    }, text('addTrial')))), /*#__PURE__*/ React.createElement("p", null, user && (!_.isNil(daysLeftOfTrial) ? "".concat(user.email, " has ").concat(daysLeftOfTrial, " days left of ").concat(trialLengthInDays, "-day trial.") : "".concat(user.email, " not yet on a trial."))), /*#__PURE__*/ React.createElement("form", {
        onSubmit: formik.handleSubmit
    }, /*#__PURE__*/ React.createElement(Control, {
        label: text('days'),
        as: "input",
        type: "text",
        name: "days",
        isFailed: formik.touched.days && !!formik.errors.days,
        value: formik.values.days,
        onBlur: formik.handleBlur,
        onChange: formik.handleChange,
        validationError: formik.touched.days && formik.errors.days,
        autoComplete: "off"
    }), /*#__PURE__*/ React.createElement(Button, {
        type: "submit",
        loading: formik.isSubmitting
    }, text('addTrial'))));
};
GiveUserTrialModal.propTypes = {
    user: T.object,
    show: T.bool.isRequired,
    onHide: T.func
};
export default GiveUserTrialModal;
